import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const AdminCourseManager = () => {
    const [courses, setCourses] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    const fetchCourses = async () => {
        setIsLoading(true);
        try {
            const token = localStorage.getItem('app_token');
            const response = await axios.get('/api/admin/courses', { headers: { Authorization: `Bearer ${token}` } });
            setCourses(response.data);
        } catch (error) {
            console.error("Failed to fetch courses:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchCourses();
    }, []);

    const handleAddNew = async () => {
        try {
            const token = localStorage.getItem('app_token');
            const response = await axios.post('/api/admin/courses', 
                { title: 'New Course Title', category: 'Uncategorized', description: '' }, 
                { headers: { Authorization: `Bearer ${token}` } }
            );
            navigate(`/admin/courses/${response.data.id}`);
        } catch (error) {
            alert('Failed to create new course.');
        }
    };

    const handleDelete = async (courseId) => {
        if (window.confirm('Are you sure you want to delete this course and all of its lectures? This cannot be undone.')) {
            try {
                const token = localStorage.getItem('app_token');
                await axios.delete(`/api/admin/courses/${courseId}`, { headers: { Authorization: `Bearer ${token}` } });
                fetchCourses();
            } catch (error) {
                alert('Failed to delete course.');
            }
        }
    };

    // --- (NEW) Function to handle status toggle ---
    const handleStatusToggle = async (id, currentStatus) => {
        try {
            const token = localStorage.getItem('app_token');
            const newStatus = !currentStatus;
            await axios.put(`/api/admin/courses/${id}/status`, 
                { isActive: newStatus },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setCourses(courses.map(course => 
                course.id === id ? { ...course, is_active: newStatus } : course
            ));
        } catch (err) {
            alert('Failed to update status.');
        }
    };

    if (isLoading) return <p>Loading courses...</p>;

    return (
        <div className="admin-content-manager">
            <div className="admin-content-header">
                <h3 className="admin-section-title">Manage Courses</h3>
                <button onClick={handleAddNew} className="btn-primary">Add New Course</button>
            </div>
            <div className="admin-table-container">
                <table className="admin-table">
                    <thead>
                        <tr><th>ID</th><th>Title</th><th>Status</th><th>Category</th><th>Price</th><th>Actions</th></tr>
                    </thead>
                    <tbody>
                        {courses.map(course => (
                            <tr key={course.id} style={{ opacity: course.is_active ? 1 : 0.5 }}>
                                <td>{course.id}</td>
                                <td>{course.title}</td>
                                <td>
                                     <div className="status-cell">
                                        <span className={`status-badge ${course.is_active ? 'active' : 'inactive'}`}>
                                            {course.is_active ? 'Active' : 'Inactive'}
                                        </span>
                                        <label className="toggle-switch">
                                            <input type="checkbox" checked={course.is_active} onChange={() => handleStatusToggle(course.id, course.is_active)} />
                                            <span className="toggle-slider"></span>
                                        </label>
                                    </div>
                                </td>
                                <td>{course.category}</td>
                                <td>₹{course.price || '0.00'}</td>
                                <td className="admin-table-actions">
                                    <Link to={`/admin/courses/${course.id}`} className="action-btn edit" title="Edit">
                                        <span className="material-icons">edit</span>
                                    </Link>
                                    <button onClick={() => handleDelete(course.id)} className="action-btn delete" title="Delete">
                                        <span className="material-icons">delete_forever</span>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdminCourseManager;
